/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Alignment_TopInputs */



/**
* | output |
* | --- |
* | "Top" |
*
* @param {Options_Watermark_Alignment_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_alignment_top = /** @type {((inputs?: Options_Watermark_Alignment_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Alignment_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сверху")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("顶部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Topo")
	return /** @type {LocalizedString} */ ("Top")
});